module.exports = __webpack_public_path__ + "img/versapay-design-1.12fa3d2e.png";